import React, { useEffect, useState } from 'react'
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { Row, Col, Table, Modal, Button, Card, Badge, Container } from 'react-bootstrap';
import Puff from 'react-loading-icons/dist/esm/components/puff';
import axios from 'axios';
import { useStateContext } from '../Context/ContextProvider';

function AllInvoiceView() {
  const [isClick, setIsClick] = useState(false);
  const [isClickPrint, setIsClickPrint] = useState(false);
  const [defaultsalesman, setDefaultSalesman] = useState('');
  const [defaultsector, setDefaultSector] = useState('all');
  const [salesman, setSalesman] = useState([]);
  const [sector, setSector] = useState([]);
  const [manualdate, setManualDate] = useState('');
  const [manualdateto, setManualDateTo] = useState('');
  const { type, userId } = useStateContext();
  const [invoiceList, setInvioceList] = useState([]);
  const [invoiceNumbersRange, setInvoiceNumbersRange] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [grandProfit, setGrandProfit] = useState(0);
  const [showProfit, setShowProfit] = useState(false); // Hidden by default
  const [grandTotals, setGrandTotals] = useState({
    totalQty: 0,
    totalAmount: 0,
    totalDiscount: 0,
    totalAfterDiscount: 0,
    totalWeight: 0,
    totalBill: 0,
    totalProfit: 0
  });

  useEffect(() => {
    if (invoiceList.length > 0) {
      if (invoiceNumbersRange.length === invoiceList.length) {
        setIsAllChecked(true);
      } else {
        setIsAllChecked(false);
      }
    }
  }, [invoiceNumbersRange, invoiceList]);

  const handleCheckAllChange = (e) => {
    if (e.target.checked) {
      setInvoiceNumbersRange(invoiceList.map((invoice) => invoice.visitor_id));
    } else {
      setInvoiceNumbersRange([]);
    }
  };

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setInvoiceNumbersRange((prev) => [...prev, id]);
    } else {
      setInvoiceNumbersRange((prev) => prev.filter((item) => item !== id));
    }
  };

  useEffect(() => {
    axios.get('/api/getsectors').then(res => {
      setSector(res.data.sectors);
    })
  }, [])

  useEffect(() => {
    axios.get('/api/getsalesman').then(res => {
      setSalesman(res.data.salesman);
      setDefaultSalesman(res.data.salesman[0]['id']);
    })
  }, [])

  // Calculate grand totals across all invoices
  const calculateGrandTotals = (invoices) => {
    const totals = {
      totalQty: 0,
      totalAmount: 0,
      totalDiscount: 0,
      totalAfterDiscount: 0,
      totalWeight: 0,
      totalBill: 0,
      totalNetAmount: 0,
      totalPayment: 0,
      totalCurrentBill: 0,
      totalProfit: 0
    };

    invoices.forEach(invoice => {
      totals.totalBill += parseFloat(invoice.total_bill || 0);
      
      if (invoice.products) {
        invoice.products.forEach(product => {
          totals.totalQty += parseFloat(product.qty || 0);
          totals.totalWeight += parseFloat(product.totalweight || 0);
          totals.totalDiscount += parseFloat(product.discounted_amount || 0);
          totals.totalAmount += parseFloat(product.total_price || 0);
          totals.totalAfterDiscount += parseFloat(product.total_after_discount || 0);
          const profit = (parseFloat(product.total_price || 0) - parseFloat(product.total_cost || 0)) - parseFloat(product.discounted_amount || 0);
          totals.totalProfit += profit;
        });
      }

      const netAmount = invoice.total_bill - invoice.discount + parseFloat(invoice.sales_tex || 0) + parseFloat(invoice.shipping || 0);
      totals.totalNetAmount += netAmount;
      totals.totalPayment += (parseFloat(invoice.total_cash || 0) + parseFloat(invoice.recieve || 0));
      
      const currentBill = parseFloat(invoice.previous_balance || 0) + netAmount - (parseFloat(invoice.total_cash || 0) + parseFloat(invoice.recieve || 0));
      totals.totalCurrentBill += currentBill;
    });

    return totals;
  };

  const handleFetchList = () => {
    setIsClick(true);
    if (manualdate === '' || manualdateto === '') {
      alert('Date Must Be Selected');
      setIsClick(false);
      return false;
    }
    
    const data = {
      'salesman': type === 'Admin' ? defaultsalesman : userId,
      'sector': defaultsector,
      'date': manualdate,
      'dateto': manualdateto
    }

    axios({
      url: 'api/get/batch/invoices',
      method: 'POST',
      data: data
    }).then((response) => {
      setInvioceList(response.data);
      setIsClick(false);
      handleViewInvoicesOnWeb(response.data);
    });
  }

  const handleViewInvoicesOnWeb = (invoices) => {
    if (invoices.length === 0) {
      alert('No invoices found');
      return;
    }
    
    setLoadingDetails(true);
    setShowInvoiceModal(true);
    
    const data = {
      'salesman': type === 'Admin' ? defaultsalesman : userId,
      'sector': defaultsector,
      'date': manualdate,
      'dateto': manualdateto,
      'visitorids': invoices.map(inv => inv.visitor_id),
    }

    axios({
      url: 'api/get/batch/invoices/detail',
      method: 'POST',
      data: data
    }).then((response) => {
      setInvoiceDetails(response.data.invoices);
      setGrandProfit(response.data.grandProfit || 0);
      setGrandTotals(calculateGrandTotals(response.data.invoices));
      setLoadingDetails(false);
    }).catch((error) => {
      console.error('Error fetching invoice details:', error);
      setLoadingDetails(false);
    });
  }

  const handleFetchReport = () => {
    setIsClickPrint(true);
    if (invoiceNumbersRange.length < 1) {
      alert('Select Invoices First');
      setIsClickPrint(false);
      return false;
    }
    const data = {
      'salesman': type === 'Admin' ? defaultsalesman : userId,
      'sector': defaultsector,
      'date': manualdate,
      'dateto': manualdateto,
      'visitorids': invoiceNumbersRange,
    }

    axios({
      url: 'api/post/batch/invoices',
      method: 'POST',
      responseType: 'blob',
      data: data
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setIsClickPrint(false);
    });
  }

  return (
    <div className='fadeInDown animated p-4'>
      {/* Filters Card */}
      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-primary text-white">
          <h4 className="mb-0">Invoice Filters</h4>
        </Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col md={3}>
              <FloatingLabel label="Date From">
                <Form.Control 
                  type="date" 
                  value={manualdate} 
                  onChange={(e) => setManualDate(e.target.value)} 
                />
              </FloatingLabel>
            </Col>
            
            <Col md={3}>
              <FloatingLabel label="Date To">
                <Form.Control 
                  type="date" 
                  value={manualdateto} 
                  onChange={(e) => setManualDateTo(e.target.value)} 
                />
              </FloatingLabel>
            </Col>
            
            <Col md={3}>
              <FloatingLabel label="Region">
                <Form.Select 
                  value={defaultsector} 
                  onChange={(e) => setDefaultSector(e.target.value)}
                >
                  <option value="all">All Regions</option>
                  {sector && sector.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Col>
            
            <Col md={3}>
              <FloatingLabel label="Sales Associate">
                <Form.Select 
                  value={defaultsalesman} 
                  onChange={(e) => setDefaultSalesman(e.target.value)}
                >
                  {salesman && salesman.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Col>
          </Row>
          
          <Row className="mt-3">
            <Col className="d-flex gap-2">
              <button 
                onClick={handleFetchList} 
                className='btn btn-warning btn-lg'
                disabled={isClick}
              >
                {isClick ? (
                  <>
                    <Puff width={20} height={20} stroke='red' className="me-2" />
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="fas fa-search me-2"></i>
                    Fetch Invoices
                  </>
                )}
              </button>
              
              {invoiceList.length > 0 && (
                <button 
                  onClick={handleFetchReport} 
                  className='btn btn-success btn-lg'
                  disabled={isClickPrint}
                >
                  {isClickPrint ? (
                    <>
                      <Puff width={20} height={20} stroke='white' className="me-2" />
                      Generating PDF...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-print me-2"></i>
                      Print Selected ({invoiceNumbersRange.length})
                    </>
                  )}
                </button>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Invoice List Table */}
      {invoiceList.length > 0 && (
        <Card className="shadow-sm">
          <Card.Header className="bg-info text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="fas fa-list me-2"></i>
              Invoice List ({invoiceList.length} records)
            </h5>
            <span className="badge bg-light text-dark">
              Selected: {invoiceNumbersRange.length}
            </span>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Table className='table table-hover table-striped' size="sm">
                <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr>
                    <th style={{ width: '5%' }}>Sr</th>
                    <th style={{ width: '25%' }}>Customer Name</th>
                    <th style={{ width: '20%' }}>Salesman</th>
                    <th style={{ width: '20%' }}>Sector</th>
                    <th style={{ width: '15%' }}>SubSector</th>
                    <th style={{ width: '10%' }}>Invoice #</th>
                    <th style={{ width: '5%', textAlign: 'center' }}>
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={handleCheckAllChange}
                        label="All"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceList.map((item, index) => (
                    <tr key={index} className={invoiceNumbersRange.includes(item.visitor_id) ? 'table-active' : ''}>
                      <td>{item.Sr}</td>
                      <td>
                        <span className="fw-bold">{item.customerName}</span>
                      </td>
                      <td>{item.salesmanName}</td>
                      <td>
                        <span className="badge bg-secondary">{item.sectorName}</span>
                      </td>
                      <td>{item.subsectorName}</td>
                      <td>
                        <span className="badge bg-primary">{item.visitor_id}</span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <Form.Check
                          type='checkbox'
                          checked={invoiceNumbersRange.includes(item.visitor_id)}
                          onChange={(e) => handleCheckboxChange(e, item.visitor_id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Empty State */}
      {invoiceList.length === 0 && !isClick && (
        <Card className="shadow-sm text-center p-5">
          <Card.Body>
            <i className="fas fa-file-invoice fa-4x text-muted mb-3"></i>
            <h4 className="text-muted">No Invoices to Display</h4>
            <p className="text-muted">Select filters and click "Fetch Invoices" to view data</p>
          </Card.Body>
        </Card>
      )}

      {/* Invoice Details Modal - Two Invoices Per Row */}
      <Modal 
        show={showInvoiceModal} 
        onHide={() => setShowInvoiceModal(false)} 
        size="xl"
        fullscreen="xl-down"
        centered
        dialogClassName="modal-98w"
      >
        <Modal.Header closeButton className="bg-gradient-primary text-white" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '10px 16px' }}>
          <Modal.Title className="w-100">
            <Container fluid>
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0">
                    <i className="fas fa-file-invoice me-2"></i>
                    Invoice Details {defaultsector === 'all' ? '- All Sectors' : ''}
                  </h5>
                  <small className="text-white-50">
                    Total Invoices: <strong>{invoiceDetails.length}</strong>
                  </small>
                </Col>
                <Col xs="auto" className="d-flex gap-3 align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <Form.Check 
                      type="switch"
                      id="profit-switch"
                      label={<span className="text-white" style={{ fontSize: '13px' }}>Show Profit Details</span>}
                      checked={showProfit}
                      onChange={(e) => setShowProfit(e.target.checked)}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ 
          maxHeight: 'calc(100vh - 180px)', 
          overflowY: 'auto',
          background: '#f8f9fa',
          padding: '15px'
        }}>
          {loadingDetails ? (
            <div className="text-center py-5">
              <Puff width={80} height={80} stroke='#667eea' />
              <h5 className="mt-4 text-muted">Loading Invoice Details...</h5>
              <p className="text-muted">Please wait while we fetch your data</p>
            </div>
          ) : (
            <div>
              {invoiceDetails.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-inbox fa-5x text-muted mb-3"></i>
                  <h4 className="text-muted">No Invoices Found</h4>
                  <p className="text-muted">Try adjusting your filters</p>
                </div>
              ) : (
                <Container fluid>
                  {/* Grand Summary - Only shown when toggle is ON */}
                  {showProfit && (
                    <Card className="mb-3 shadow-sm border-0" style={{ 
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      fontSize: '14px'
                    }}>
                      <Card.Body className="py-2 px-3">
                        <Row className="text-center">
                          <Col md={6}>
                            <small className="text-white-50 d-block">Total Profit (Products)</small>
                            <h5 className="mb-0">Rs {grandTotals.totalProfit.toFixed(2)}</h5>
                          </Col>
                          <Col md={6}>
                            <small className="text-white-50 d-block">Grand Profit</small>
                            <h5 className="mb-0">Rs {grandProfit.toFixed(2)}</h5>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  )}

                  {/* Invoices Grid - Two Per Row */}
                  <Row className="g-3">
                    {invoiceDetails.map((invoice, index) => (
                      <Col md={12} key={index}>
                        <Card className="shadow-sm border-0 h-100" style={{ fontSize: '16px' }}>
                          {/* Invoice Header */}
                          <Card.Header style={{ 
                            background: 'linear-gradient(to right, #f8f9fa, #e9ecef)',
                            borderBottom: '2px solid #dee2e6',
                            padding: '8px 12px'
                          }}>
                            <Row className="align-items-center g-2">
                              <Col xs="auto">
                                <img 
                                  src={`https://salmantradersv1.posreact.com/softwareapis/public/images/${invoice.logo}`}
                                  alt="logo" 
                                  style={{ height: '35px', width: '35px', borderRadius: '6px' }}
                                />
                              </Col>
                              <Col>
                                <div className="fw-bold text-primary" style={{ fontSize: '13px' }}>
                                  {invoice.slogan_heading}
                                </div>
                                <small className="text-muted" style={{ fontSize: '10px' }}>
                                  {invoice.slogan_subheading} | {invoice.phone}
                                </small>
                              </Col>
                              <Col xs="auto" className="text-end">
                                <Badge bg="info" className="mb-1" style={{ fontSize: '11px' }}>
                                  Invoice #{invoice.invoice_id}
                                </Badge>
                                <br />
                                <Badge bg="secondary" style={{ fontSize: '10px' }}>
                                  {invoice.manual_date}
                                </Badge>
                              </Col>
                            </Row>
                          </Card.Header>

                          <Card.Body className="p-2">
                            {/* Customer & Invoice Info */}
                            <Row className="mb-2 g-2">
                              <Col xs={6}>
                                <div className="border rounded p-2 bg-light" style={{ fontSize: '14px' }}>
                                  <div className="mb-1">
                                    <strong>Customer:</strong><br/>
                                    {invoice.customer_name}
                                  </div>
                                   <div className="mb-1">
                                    <strong>Customer:</strong><br/>
                                    {invoice.customer_cnic}
                                  </div>
                                   <div className="mb-1">
                                    <strong>Address:</strong> {invoice.sector_name}
                                  </div>
                                  <div className="mb-1">
                                    <strong>Phone:</strong> {invoice.customer_phone}
                                  </div>
                                  <div>
                                    <strong>Status:</strong>{' '}
                                    <Badge bg={invoice.secondname === '0' ? 'success' : 'warning'} style={{ fontSize: '9px' }}>
                                      {invoice.secondname === '0' ? 'Filer' : 'Non-Filer'}
                                    </Badge>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <div className="border rounded p-2 bg-light" style={{ fontSize: '14px' }}>
                                  <div className="mb-1">
                                    <strong>Salesman:</strong><br/>
                                    {invoice.salesman_name}
                                  </div>
                                 
                                  <div>
                                    <strong>Phone:</strong> {invoice.salesman_phone}
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            {/* Products Table - Discount always visible */}
                            {invoice.products && invoice.products.length > 0 && (
                              <div className="table-responsive mb-2">
                                <Table className="table table-bordered table-sm mb-0" style={{ fontSize: '10px' }}>
                                  <thead className="table-secondary" style={{ fontSize: '16px' }}>
                                    <tr>
                                      <th className="text-center py-1" style={{ width: '4%' }}>#</th>
                                      <th className="py-1" style={{ width: '22%' }}>Item</th>
                                      <th className="text-center py-1" style={{ width: '7%' }}>Qty</th>
                                      <th className="text-end py-1" style={{ width: '10%' }}>Rate</th>
                                      <th className="text-end py-1" style={{ width: '10%' }}>Weight</th>
                                      <th className="text-end py-1" style={{ width: '11%' }}>Total</th>
                                      <th className="text-end py-1" style={{ width: '10%' }}>Discount</th>
                                      <th className="text-end py-1" style={{ width: '13%' }}>Net Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      let totalQty = 0, totalWeight = 0, totalDiscount = 0;
                                      let totalAmount = 0, totalAfterDiscount = 0;
                                      
                                      return (
                                        <>
                                          {invoice.products.map((product, idx) => {
                                            totalQty += parseFloat(product.qty || 0);
                                            totalWeight += parseFloat(product.totalweight || 0);
                                            totalDiscount += parseFloat(product.discounted_amount || 0);
                                            totalAmount += parseFloat(product.total_price || 0);
                                            totalAfterDiscount += parseFloat(product.total_after_discount || 0);
                                            
                                            return (
                                              <tr key={idx} style={{fontSize:'14px'}}>
                                                <td className="text-center py-0">{idx + 1}</td>
                                                <td className="py-0" style={{ fontSize: '16px' }}>
                                                  {product.product_name?.substring(0, 20)}
                                                  {product.product_name?.length > 20 ? '...' : ''}
                                                </td>
                                                <td className="text-center py-0">{product.qty}</td>
                                                <td className="text-end py-0">{parseFloat(product.unitsaleprice).toFixed(1)}</td>
                                                <td className="text-end py-0">{parseFloat(product.totalweight || 0).toFixed(1)}</td>
                                                <td className="text-end py-0">{parseFloat(product.total_price).toFixed(1)}</td>
                                                <td className="text-end py-0 text-danger">
                                                  {parseFloat(product.discounted_amount || 0).toFixed(1)}
                                                </td>
                                                <td className="text-end py-0 fw-bold text-success">
                                                  {parseFloat(product.total_after_discount).toFixed(1)}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                          <tr className="table-primary fw-bold" style={{ fontSize: '16px' }}>
                                            <td colSpan="2" className="text-end py-0">Total:</td>
                                            <td className="text-center py-0">{totalQty}</td>
                                            <td className="text-end py-0"></td>
                                            <td className="text-end py-0">{totalWeight.toFixed(1)}</td>
                                            <td className="text-end py-0">{totalAmount.toFixed(1)}</td>
                                            <td className="text-end py-0 text-danger">{totalDiscount.toFixed(1)}</td>
                                            <td className="text-end py-0 text-success">{totalAfterDiscount.toFixed(1)}</td>
                                          </tr>
                                        </>
                                      );
                                    })()}
                                  </tbody>
                                </Table>
                              </div>
                            )}

                            {/* Summary Section */}
                            <div className="border rounded p-2 bg-light" style={{ fontSize: '16px' }}>
                              <Row className="g-0">
                                <Col xs={6} className="border-end pe-2">
                                  <div className="d-flex justify-content-between mb-1">
                                    <span>Total Bill:</span>
                                    <strong>Rs {parseFloat(invoice.total_bill).toFixed(1)}</strong>
                                  </div>
                                  <div className="d-flex justify-content-between mb-1 text-danger">
                                    <span>Discount:</span>
                                    <strong>- Rs {parseFloat(invoice.discount || 0).toFixed(1)}</strong>
                                  </div>
                                  {showProfit && invoice.shipping > 0 && (
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>Shipping:</span>
                                      <span>Rs {parseFloat(invoice.shipping).toFixed(1)}</span>
                                    </div>
                                  )}
                                  {invoice.sales_tex > 0 && (
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>Adv Tax:</span>
                                      <span>Rs {Math.round(invoice.sales_tex * 100) / 100}</span>
                                    </div>
                                  )}
                                  <div className="d-flex justify-content-between border-top pt-1 mt-1">
                                    <span>Net Amount:</span>
                                    <strong className="text-primary">
                                      Rs { 
                                         Math.round((invoice.total_bill - invoice.discount + parseFloat(invoice.sales_tex || 0) + parseFloat(invoice.shipping || 0)) * 100) / 100
                                     }
                                    </strong>
                                  </div>
                                </Col>
                                <Col xs={6} className="ps-2">
                                
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>Pre Balance:</span>
                                      <span>Rs {Math.round(invoice.previous_balance * 100) / 100}</span>
                                    </div>
                              
                                  <div className="d-flex justify-content-between mb-1 text-success">
                                    <span>Payment:</span>
                                    <span>Rs {(parseFloat(invoice.total_cash || 0) + parseFloat(invoice.recieve || 0)).toFixed(1)}</span>
                                  </div>
                                  <div className="d-flex justify-content-between border-top pt-1 mt-1">
                                    <span>Current Bill:</span>
                                    <strong className="text-danger">
                                      Rs {
                                         Math.round((parseFloat(invoice.previous_balance || 0) + (invoice.total_bill - invoice.discount + parseFloat(invoice.sales_tex || 0) + parseFloat(invoice.shipping || 0)) - (parseFloat(invoice.total_cash || 0) + parseFloat(invoice.recieve || 0))) * 100) / 100
                                      }
                                    </strong>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Container>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light py-2">
          <Button 
            variant="outline-secondary" 
            size="sm" 
            onClick={() => setShowInvoiceModal(false)}
          >
            <i className="fas fa-times me-1"></i>Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Custom CSS */}
      <style>{`
        .modal-98w {
          max-width: 98% !important;
        }
        
        @media (min-width: 1400px) {
          .modal-98w {
            max-width: 1600px !important;
          }
        }
        
        .modal-body {
          padding: 15px !important;
        }
        
        .form-switch .form-check-input:checked {
          background-color: #28a745;
          border-color: #28a745;
        }
        
        .form-switch .form-check-input {
          cursor: pointer;
        }
        
        .form-check-label {
          cursor: pointer;
        }
      `}</style>
    </div>
  )
}

export default AllInvoiceView